export default function StatCard({
  title,
  value,
  subtext,
  icon: Icon,
  iconColor
}) {
  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-6">
      <div className="flex items-start justify-between mb-4">
        <h3 className="text-sm text-gray-600">{title}</h3>
        <Icon className={`w-5 h-5 ${iconColor}`} />
      </div>
      <p className="text-4xl font-bold text-gray-900 mb-2">{value}</p>
      <p
        className={`text-sm ${
          subtext === "All systems operational"
            ? "text-green-600 font-medium"
            : "text-gray-600"
        }`}
      >
        {subtext}
      </p>
    </div>
  );
}
